export default {"src":"/_next/static/media/card-attn-code.9045e6e3.svg","height":1671,"width":713,"blurWidth":0,"blurHeight":0};